import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HeaderComponent } from './shared/header/header.component';
import { NavlinkComponent } from './shared/navlink/navlink.component';
import { StyleDirectionService } from './services/style-direction.service';
import { HeroComponent } from './components/hero/hero.component';
import { NewarrivedComponent } from './components/newarrived/newarrived.component';
import { ServicesandproductsComponent } from './components/servicesandproducts/servicesandproducts.component';
import { ClientsComponent } from './components/clients/clients.component';
import { FooterComponent } from './shared/footer/footer.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'MIW';
  Direction: string = 'ltr';

  constructor(
    private translate: TranslateService,
    private styleDirectionService: StyleDirectionService
  ) {
    //// Get the stored locale from localStorage or default to Arabic
    //const storedLang = localStorage.getItem('locale') || 'ar';
    //this.translate.setDefaultLang(storedLang); // Set default language
    //this.translate.use(storedLang); // Use the stored language

    //// Update the direction and apply styles based on language
    //this.setDirectionAndStyles(storedLang);


    const storedLang = localStorage.getItem('locale') || 'ar';
    this.translate.setDefaultLang(storedLang);
    this.translate.use(storedLang);
    localStorage.setItem('locale', storedLang);

    // Update the direction and apply styles based on language
    this.setDirectionAndStyles(storedLang)
  }

  setDirectionAndStyles(storedLang: string) {
    if (storedLang === 'ar') {
      this.styleDirectionService.fillData(true);
    } else {
      this.styleDirectionService.fillData(false);
    }
  }

  //setDirectionAndStyles(storedLang: string) {
  //  if (storedLang === 'ar') {
  //    this.Direction = 'rtl';
  //    this.styleDirectionService.fillData(true); // Load RTL Bootstrap
  //  } else {
  //    this.Direction = 'ltr';
  //    this.styleDirectionService.fillData(false); // Load LTR Bootstrap
  //  }
  //}
}
